import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useLogout } from 'shared/hooks'

const LoggingOut = () => {
  const { handleLoggingOut } = useLogout()
  const queryClient = useQueryClient()

  useEffect(() => {
    handleLoggingOut()
    queryClient.clear()
    window.location.replace('/logged-out')
  }, [handleLoggingOut, queryClient])

  return null
}

export default LoggingOut
